import { AppConstants } from '../constants/AppConstants';

const EnumActions = Object.freeze({
    WINDOW_WIDTH_CHANGED: 'WINDOW_WIDTH_CHANGED',
    NOTIFY_MESSAGE_ADD: 'NOTIFY_MESSAGE_ADD',
    NOTIFY_MESSAGE_DELETE: 'NOTIFY_MESSAGE_DELETE',
    LOADER_SHOW: 'LOADER_SHOW',
    LOADER_HIDE: 'LOADER_HIDE'
});

module.exports.EnumAppActions = EnumActions;

class BaseActions {
    constructor() {
        //console.log("[BaseActions] constructor");
        //this._baseDispatcher = BaseDispatcher;
    }
    //  get BaseDispatcher(){
    // return this._baseDispatcher;
    //    console.log("[BaseActions] BaseDispatcher");
    // return BaseDispatcher;
    //}

    get AppConstants() {
        return AppConstants;
    }

    getErrorMessage(jqxhr, textStatus, error) {
        let message = null;

        console.log("Request Failed: " + textStatus + ", " + error + ' ' + jqxhr.responseText);
        if (jqxhr.readyState === 4) {
            // HTTP error (can be checked by XMLHttpRequest.status and XMLHttpRequest.statusText)
            message = textStatus + ", " + error + ' ' + jqxhr.responseText;
        }
        else if (jqxhr.readyState === 0) {
            // Network error (i.e. connection refused, access denied due to CORS, etc.)
            message = textStatus + ", network connection";
        }
        else {
            // something weird is happening
            message = textStatus + ", " + error + ' ' + jqxhr.responseText;
        }

        return message;
    }

    getJsonV1(fileName, callback) {

        //  if(! window.FileReader) {
        //    throw "The File APIs are not fully supported in this browser." 
        // }

        // Check for the various File API support.
        /*
        if (window.File && window.FileReader && window.FileList && window.Blob) {
          // Great success! All the File APIs are supported.
        } else {
          alert('The File APIs are not fully supported in this browser.');
        }*/





        //fileName = "file:///C:/Dev2015/HTML5/DotNET/VisualStudioCode/Template01/release/stubs/investimenti.movimenti.json";
        //fileName = "data:///stubs/investimenti.movimenti.json";

        console.log("[BaseActions] getJson" + fileName);
        /*
        'data:text/html;charset=utf-8,' +
            encodeURIComponent( // Escape for URL formatting
                '<!DOCTYPE html>'+
                '<html lang="en">'+
                '<head><title>Embedded Window</title></head>'+
                '<body><h1>42</h1></body>'+
                '</html>'
            )*/


        /*  var jqxhr = $.getJSON(fileName, function () {
              console.log("success");
          })
              .done(function () {
                  console.log("second success");
              })
              .fail(function () {
                  console.log("error");
              })
              .always(function () {
                  console.log("complete");
              });
  
  */




        //var reader = new FileReader();
        //reader.readAsDataURL( new File (fileName));



        let rawFile = new XMLHttpRequest();
        rawFile.overrideMimeType("application/json");
        rawFile.open("GET", fileName, true);

        rawFile.onreadystatechange = function () {

            console.log('readyState' + rawFile.readyState);
            //console.log('\t' + rawFile.responseText);

            if (rawFile.readyState === 4 && rawFile.status === "200") {
                //console.log('\t' + rawFile.responseText);
                callback(JSON.parse(rawFile.responseText));
            }
        };

        rawFile.send();
    }


   
    showLoader() {
        console.log("[BaseActions] show Loader  ");
        return {
            type: EnumActions.LOADER_SHOW
        }
    }
    
    hideLoader() {
        console.log("[BaseActions] hide Loader  ");
        return {
            type: EnumActions.LOADER_HIDE
        }
    }
}

export default BaseActions;